module.exports = __webpack_public_path__ + "static/media/02_avatar_animal.3f586b89.png";